import Swiper from 'swiper/bundle'

export default function ImageGallery() {
	const containers = document.querySelectorAll('.mtt-image-gallery')

    if (containers.length) {
        for (let i = 0; i < containers.length; i++) {
            const container = containers[i];
            
            const slider = new Slider(container)
            slider.init()
        }
    }
}

class Slider {
    constructor(container) {
        this.container = container
        this.swiperContainer = this.container.querySelector('.swiper-container')

        this.imageTextArray = this.swiperContainer.getAttribute('data-image-texts')
        this.imageTextArray = JSON.parse(this.imageTextArray)  

        this.init = () => {
            this.addSlider()
            this.addLightbox()

            this.swiper.on('slideChangeTransitionEnd', () => {
                this.addLightbox()
                this.showFullscreenIcon()
            });
        }    
    }

    addSlider() {        
    
        this.swiper = new Swiper(this.swiperContainer, {
            slidesPerView: 1,
            spaceBetween: 20,
            speed: 800,
            allowTouchMove: false,
            watchOverflow: true,           
            navigation: {
              nextEl: this.container.querySelector('.slider-button--next'),
              prevEl: this.container.querySelector('.slider-button--prev')
            },
            lazy: {
                loadPrevNext: true,
                loadPrevNextAmount: 2
            },
            observer: true,
            observeParents: true,
            breakpoints: {
              580: {
                slidesPerView: 1,
                spaceBetween: 40
              },
              851: {
                slidesPerView: 1,
                spaceBetween: 0
              },            
            }
        })

        this.swiper.on('slideChange', () => {
            this.hideFullscreenIcon()
            this.showCorrectText()
        });
    }

    addLightbox() {
        const currentSlide = this.container.querySelector('.swiper-slide-active')        

        currentSlide.classList.add('open-modal')
        currentSlide.classList.add('show-icon')
        currentSlide.setAttribute('data-id', 'image-gallery-modal')
        const modal = document.querySelector('.modal[data-id="image-gallery-modal"]')   
        const img = document.createElement('img')                

        currentSlide.addEventListener('click', () => {            
            modal.querySelector('.modal-inner-content').innerHTML = ''
            const currentImgSrc = currentSlide.querySelector('img').getAttribute('src')     
            img.setAttribute('src', currentImgSrc)

            modal.querySelector('.modal-inner-content').appendChild(img)
        })
    }

    showCorrectText() {
        const index = this.swiper.activeIndex
        const text = this.imageTextArray[index]
        const countDest = this.container.querySelector('.count')
        const textDest = this.container.querySelector('.dest')

        countDest.innerHTML = index + 1        
        textDest.innerHTML = text
    }

    hideFullscreenIcon() {
        const currentSlide = this.container.querySelector('.swiper-slide-active')    
        currentSlide.classList.remove('show-icon')
    }

    showFullscreenIcon() {
        const currentSlide = this.container.querySelector('.swiper-slide-active') 
        currentSlide.classList.add('show-icon');
    }
}